<template>
  <div class="set-daily-remid">
    <van-cell center title="每日一题提醒开关">
      <template #right-icon>
        <van-switch v-model="checked" size="24" @change="handleChange" active-color="#74D885" />
      </template>
    </van-cell>
  </div>
</template>
<script>
import {dailyQuestionRemind, updateDailyQuestionRemind} from '../../api/questionBank'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  data() {
    return {
      checked: false
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted() {
    dailyQuestionRemind({
      userId: this.userInfo.id
    }).then((res) => {
      this.checked = res.data
    })
  },
  methods: {
    handleChange() {
      let params = {
        userId: this.userInfo.id,
        dailyQuestionRemind: this.checked ? 1 : 2
      }
      updateDailyQuestionRemind(params).then((res) => {
        this.checked = res.data
      })
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.set-daily-remid {
  background-color: #F7F9FB;
  width: 100vw;
  min-height: 100vh;
  padding: 15px;
  box-sizing: border-box;
  /deep/ .van-cell {
    border-radius: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/person/setDailyRemid.vue